import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, ActivityIcon, SettingsIcon, PlusIcon, MapIcon, ServerIcon } from 'lucide-react';
const PAYKIT_ICON = 'https://cdn.magicpatterns.com/uploads/dGPwcszoTH3R7hr1KgQtE4/PayKit.png';
export function AppLayout() {
  const location = useLocation();
  const navItems = [{
    path: '/dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    path: '/blueprint',
    label: 'Blueprint',
    icon: MapIcon
  }, {
    path: '/providers',
    label: 'Providers',
    icon: ServerIcon
  }, {
    path: '/monitoring',
    label: 'Monitoring',
    icon: ActivityIcon
  }];
  return <div className="min-h-screen flex bg-background" data-id="element-226">
      {/* Sidebar */}
      <aside className="w-64 border-r border-border bg-muted hidden md:flex flex-col" data-id="element-227">
        <div className="h-16 flex items-center px-6 border-b border-border" data-id="element-228">
          <Link to="/dashboard" className="flex items-center gap-2" data-id="element-229">
            <img src={PAYKIT_ICON} alt="PayKit" className="w-8 h-8 rounded-lg" data-id="element-230" />
            <span className="text-lg font-bold tracking-tight text-foreground" data-id="element-231">
              PayKit
            </span>
          </Link>
        </div>

        <div className="p-4" data-id="element-232">
          <Link to="/setup" className="flex items-center justify-center gap-2 w-full bg-primary text-primary-foreground hover:opacity-90 px-4 py-2 rounded-md text-sm font-medium transition-opacity mb-6" data-id="element-233">
            <PlusIcon className="w-4 h-4" data-id="element-234" />
            New Setup
          </Link>

          <nav className="space-y-1" data-id="element-235">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-accent hover:text-foreground'}`} data-id="element-236">
                  <item.icon className="w-4 h-4" data-id="element-237" />
                  {item.label}
                </Link>;
          })}

            <div className="my-4 border-t border-border" data-id="element-238"></div>

            <Link to="/settings" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/settings' ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-accent hover:text-foreground'}`} data-id="element-239">
              <SettingsIcon className="w-4 h-4" data-id="element-240" />
              Settings
            </Link>
          </nav>
        </div>

        <div className="mt-auto p-4 border-t border-border" data-id="element-241">
          <div className="flex items-center gap-3 px-3 py-2" data-id="element-242">
            <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm" data-id="element-243">
              A
            </div>
            <div className="flex flex-col" data-id="element-244">
              <span className="text-sm font-medium text-foreground" data-id="element-245">
                Alex Builder
              </span>
              <span className="text-xs text-muted-foreground" data-id="element-246">Acme Corp</span>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-247">
        {/* Mobile Header */}
        <header className="md:hidden h-16 border-b border-border bg-muted flex items-center px-4 justify-between" data-id="element-248">
          <Link to="/dashboard" className="flex items-center gap-2" data-id="element-249">
            <img src={PAYKIT_ICON} alt="PayKit" className="w-8 h-8 rounded-lg" data-id="element-250" />
            <span className="text-lg font-bold tracking-tight text-foreground" data-id="element-251">
              PayKit
            </span>
          </Link>
          <button className="p-2 text-muted-foreground" data-id="element-252">
            <LayoutDashboardIcon className="w-5 h-5" data-id="element-253" />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto p-4 md:p-8" data-id="element-254">
          <div className="max-w-6xl mx-auto" data-id="element-255">
            <Outlet data-id="element-256" />
          </div>
        </div>
      </main>
    </div>;
}